<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>
<div class="demo-banner" *ngIf="env.DEMO != ''">
  <div class="scroll-text">
    ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
  </div>
</div>

<div class="displayflex">
  <div class="width50 imgcontainer">
    <img class="fullwidth" src="../assets/images/2025UICloudBite.jpg" />
  </div>
  <div class="width50 displayflex pagecontainer">
    

    <span class="row-container spacing eposmanagerposition" [class.banner]="env.DEMO != ''">
      <!-- <span class="epostext">&nbsp;ePos</span>
      <span class="managertext">&nbsp;Manager</span> -->
      <!-- <img class="eposmanagerlogo" src="../assets/images/cloudbite-small.svg" /> -->
    </span>

    <div class="justifycenter">
      <form class="form aligncenter">
        <div class="col-sm-8 hellocontainer col-lg-10 justify-content-center">
          <div class="mb-4 text-center">
            <img class="eposmanagerlogo" src="/assets/images/qas-logo.png" />
          </div>
          <!-- <span class="hellotext">Hello! Let's get started</span> -->
          <!-- <span class="signintext">Sign in </span> -->
        </div>
        <div class="mat-small alert alert-danger col-sm-8 col-lg-10" [@slideInOut]="errorDisplay">
          {{errorMsg}}
        </div>

        <div class="form-group col-sm-8 pl-0 mt-10 col-lg-10">
          <label class="labeltext">Please enter subdomain name:</label>
          <div class="input-group d-flex align-items-center">
            <input appBlockQuotes type="text" id="homePageEmail" name="homePageEmail" class="form-control customformcontrol" [disabled]="loading" [(ngModel)]="subdomainName" (keydown.enter)="login()">
            <input appBlockQuotes type="text" class="form-control customformcontrol ms-2 placeholder-text" [value]="domain" [disabled]="true">
          </div>
        </div>
        
        <div class="form-group col-sm-8 pl-0 col-lg-10">
          <button mat-flat-button [class.spinner]="loading" [disabled]="loading" type="button" (click)="login()"
            id="loginButton" color="primary">
            <span *ngIf="!loading">Continue</span> 
            <i class="pi pi-spin pi-spinner py-1" *ngIf="loading" style="font-size: 1.5rem; color: white; "></i>
        </button>
        </div>
      </form>
    </div>
    <div class="footertext">
      <img class="poweredlogo" src="/assets/images/powered-by.png" />
      <app-footer></app-footer>
    </div>
  </div>
</div>